module.exports = __webpack_public_path__ + "static/media/add.69c0793b.png";